import { QueryClient } from "@tanstack/react-query";
import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from "./stale-times";
import { isApiError } from "../../errors";

const MAX_QUERY_RETRIES = 2;

/** Build a QueryClient with the locked defaults. Factory form keeps tests isolated. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_TIME,
        gcTime: DEFAULT_GC_TIME,
        retry: (failureCount, error) => {
          // Never retry 4xx — deterministic and won't self-heal. The axios interceptor
          // already handles the 401→refresh case before the error reaches Query.
          if (isApiError(error) && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < MAX_QUERY_RETRIES;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Writes are intentional — do not auto-retry; surface the error to the caller.
        retry: false,
      },
    },
  });
}

/** App singleton. Mounted in QueryClientProvider in the app-shell phase. */
export const queryClient = createQueryClient();
